<template>
  <nav id="sidebar">
    <ul class="col-md-12 no-padding sidebar-menu">

      <li
        id="btn-expand-sidebar-toggle"
        @click="sidebarToggle">
        <a>
          <i class="icon fold fas fa-angle-double-left"/>
          <i class="icon expend fas fa-angle-double-right"/>
          <span>{{ $t('message.short_menu') }}</span>
          <i class="fas fa-angle-left"/>
        </a>
      </li>

      <template v-for="(item, index) in $store.state.app.sidebar">
        <template v-if="item.submenus !== undefined">
          <li
            :class="[`sub-menu ${item.activeClass}`, { hide: item.show === false }]"
          >
            <a>
              <i :class="'icon ' + item.icon"/>
              <span>{{ $t(item.name) }}</span>
              <i class="fas fa-circle current"/>
              <i class="fas fa-angle-left"/>
              <i class="line-left"/>
              <i class="line-bottom"/>
            </a>
            <ul>
              <li
                v-for="(item_, index_) in item.submenus"
                :key="index_"
                :class="[item_.activeClass, { hide: item_.show === false }]"
              >
                <router-link
                  :to="{ name: item_.router.name, query: item_.router.query || null }"
                >
                  <span>{{ $t(item_.name) }}</span>
                  <i class="fas fa-circle"/>
                  <i class="line-left"/>
                  <i class="line-bottom"/>
                </router-link>
              </li>
            </ul>
          </li>
        </template>

        <template v-if="item.submenus === undefined">
          <li
            :class="[`no-sub-menu ${item.activeClass}`, { hide: item.show === false }]"
          >
            <router-link
              :to="{ name: item.router.name, query: item.router.query }"
            >
              <i :class="'icon ' + item.icon"/>
              <span>{{ $t(item.name) }}</span>
              <i class="fas fa-circle current"/>
              <i class="line-left"/>
            </router-link>
          </li>
        </template>
      </template>

    </ul>

    <div class="overlay"/>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      uiOptions: 'getUIOptions',
    }),
  },

  mounted () {
    this.updateUI()
  },

  updated () {
    this.updateUI()
  },

  methods: {
    sidebarToggle () {
      const t = this
      setTimeout(() => {
        const isSidebarRegular = $('body').attr('class').indexOf('sidebar-regular') >= 0
        let sidebarVal = ''
        if (isSidebarRegular) {
          sidebarVal = 'regular'
        } else {
          sidebarVal = 'expanded'
        }
        // dispatch
        t.$store.dispatch('updateUIOptions', {
          sidebar: sidebarVal,
        })
      }, 10)
    },
    updateUI () {
      let md = new MobileDetect(window.navigator.userAgent)

      // set ui from local stoage
      $('body').removeClass('sidebar-regular sidebar-expanded')
      if (this.uiOptions.sidebar == 'expanded') {
        $('body').addClass('sidebar-expanded')
      } else {
        $('body').addClass('sidebar-regular')
      }

      // update active class
      let isSidebarRegular = $('body').attr('class').indexOf('sidebar-regular') >= 0
      if (isSidebarRegular && !md.phone()) {
        $('#sidebar ul > li.opened')
          .removeClass('opened')
          .addClass('active')
      }

      // set sidebar to expanded if user is mobile
      if (md.phone()) {
        $('body').removeClass('sidebar-regular sidebar-expanded')
        $('body').addClass('sidebar-expanded')
      }
    },
  },
}
</script>

<style scoped>
#sidebar .overlay {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  right: 239px;
  background: rgba(0,0,0,.6);
  z-index: 1;
  display: none;
}

.hide {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/apps/common/SideBar.vue